<template>
  <v-container>  
    <v-row class="pb-4">
      <v-col>
        <v-icon>mdi-map-marker-radius</v-icon>
        <span class="headline mx-2">State Access</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height" 
      align="center"
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>

    <div v-else>
      <v-row v-if="noOfStates > 0">
        <v-col 
          v-for="state in filteredStateDepartments"
          :key="state.state"
          cols="12"
          md="6" 
          lg="3"
        >
          <v-card>
            <v-card-actions>              
              <span class="body-2 font-weight-regular"> {{ state.state }} </span>
              <v-spacer />
              <v-btn 
                icon 
                @click="onClickHandler(state.state)"
              >
                <v-icon>{{ shows[state.state] ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-slide-y-transition>
              <div v-show="shows[state.state]">
                <v-divider class="company" />
                <v-list dense>
                  <v-list-item 
                    v-for="department in state.departments" 
                    :key="department.name"
                  >
                    <v-list-item-content class="font-weight-light">
                      {{ department }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>            
            </v-slide-y-transition>
          </v-card>
        </v-col>        
      </v-row>
      <v-row v-else>
        <v-col>
          <span class="mx-2"> No data available </span>
        </v-col>
      </v-row>

      <div v-if="noOfStates >= 9">
        <a 
          v-if="filter" 
          @click.stop="filter = false"
        >Show more ...</a> 
        <a 
          v-else 
          @click.stop="filter = true"
        >Show less ...</a>
      </div>
    </div> 

    <v-card-actions v-show="$hasPermissionTo(['update admin states']) && !$store.state.isMyProfile">
      <v-spacer />
      <user-state-dialog-edit
        :no-of-states="noOfStates"
        :employee-uid="employeeUid"
        @created="loadUserStateAccess"
      />
    </v-card-actions>
  </v-container>
</template>

<script>

  export default {
    components: {
      UserStateDialogEdit: () => import('@/components/user/state/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        shows: [],
        filter: true,
        userStates: [],
        states: [],
        loading: false,
        progressing: false,
        edit: false,
        statesSelected: [],
      }
    },

    computed: {
      noOfStates () {
        return this.statesSelected.length
      },

      filteredStateDepartments () {
        if (this.noOfStates < 9) return this.statesSelected

        return this.filter ? this.statesSelected.slice(0, 8) : this.statesSelected
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserStateAccess()
          }
        },
      },
    },

    created () {
      this.$api.states().list()
        .then(response => {
          this.states = response.data
        })
        .catch(() => {})
        .then(() => {
          this.progressing = false
        })
    },

    methods: {
      loadUserStateAccess () {
        this.$api.adminStates().list(this.employeeUid)
          .then(response => {
            if (response.data !== null && response.status === 200) {
              response.data.map(res => {
                res.state_name = res.state.name
              })

              let groupedData = _(response.data).groupBy('state_name')
                .map((items, stateName) => {
                  return {
                    state: stateName,
                    departments: _.map(items, 'department.name'),
                  }
                }).value()

              this.statesSelected = groupedData
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },

      onClickHandler (id) {
        this.$set(this.shows, id, !this.shows[id])
      },
    },
  }
</script>
